import { render } from "./WhatIsBlockstory.vue?vue&type=template&id=50eb9837&scoped=true"
import script from "./WhatIsBlockstory.vue?vue&type=script&lang=js"
export * from "./WhatIsBlockstory.vue?vue&type=script&lang=js"

import "./WhatIsBlockstory.vue?vue&type=style&index=0&id=50eb9837&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/home/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50eb9837"]])

export default __exports__